import React from "react";

const VerbIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.25 8.81079H14.25"
      stroke="#677791"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.25 11.3108H14.25"
      stroke="#677791"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.75 3.18579H4.25C3.90482 3.18579 3.625 3.46561 3.625 3.81079V16.3108C3.625 16.656 3.90482 16.9358 4.25 16.9358H16.75C17.0952 16.9358 17.375 16.656 17.375 16.3108V3.81079C17.375 3.46561 17.0952 3.18579 16.75 3.18579Z"
      stroke="#677791"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 3.18579V16.9358"
      stroke="#677791"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default VerbIcon;
